import React, { useMemo, useRef, useEffect } from "react";
import ReactFlow, { Controls, MiniMap, ReactFlowInstance } from "reactflow";
import { Box } from "@mui/material";
import "reactflow/dist/style.css";
import {
  ActionNode,
  ExitNode,
  LogicNode,
  TriggerNode,
  TimingNode,
} from "../CustomNodes";
import { AddEdge } from "../CustomEdges";
import { useWorkflowsBuilderPageView } from "../../WorkflowsBuilderPage.context";

export function FlowContainer() {
  const { workflowData } = useWorkflowsBuilderPageView();
  const { nodes, edges } = workflowData?.structure;

  const reactFlowWrapper = useRef<HTMLDivElement>(null);
  const reactFlowInstance = useRef<ReactFlowInstance | null>(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      reactFlowInstance.current?.fitView({ duration: 500, maxZoom: 1 });
    }, 50);
    return () => clearTimeout(timer);
  }, [nodes]);

  const nodeTypes = useMemo(
    () => ({
      TRIGGER: TriggerNode,
      ACTION: ActionNode,
      LOGIC: LogicNode,
      EXIT: ExitNode,
      TIMING: TimingNode,
    }),
    []
  );

  const edgeTypes = useMemo(() => ({ ADD: AddEdge }), []);

  return (
    <Box
      sx={(theme) => ({
        width: "100%",
        height: "calc(100vh - 60px)",
        background: theme.palette.background.default,
        "& .react-flow__node": {
          transition: "transform 300ms ease",
        },
      })}
      ref={reactFlowWrapper}
    >
      <ReactFlow
        onInit={(instance) => (reactFlowInstance.current = instance)}
        nodes={nodes}
        edges={edges}
        edgeTypes={edgeTypes}
        nodeTypes={nodeTypes}
        panOnScroll
        minZoom={0.5}
        maxZoom={1}
        panOnDrag
        selectionKeyCode={null}
        zoomOnDoubleClick={true}
        zoomOnPinch={true}
      >
        <Controls />
        <MiniMap />
      </ReactFlow>
    </Box>
  );
}
